// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import Content from './content';
import { _ } from "~/i18n";
import { CONFIG } from "~/config";

export default class PhotoAuthor extends Content {
	_build() {
		this._dom.container.classList.add("content-photoauthor");
		if(this._data.authorName) {
			this._dom.container.innerHTML = "<em>" + _("detail.content.photoAuthor") + ": </em>";

			if (this._data.userPublicId) {
				var a = node("a", { href: "https://" + CONFIG.BASE_URL + "/?moje-mapy&cat=fotografie&mid=" + this._data.userPublicId });
				a.appendChild(JAK.ctext(this._data.authorName));
				this._dom.container.appendChild(a);
				this._ec.push(JAK.Events.addListener(a,"click",this, "_authorClick"));
			} else if(this._data.authorName) {
				this._dom.container.appendChild(JAK.ctext(this._data.authorName));
			}
		}
	}

	_authorClick(e,elm) {
		e.preventDefault();

		Mapy.Util.openPhotogallery(this._data.userPublicId);
		Mapy.getComponent("history").save();
	}
}
